// ----------------------------------------------------------------------
export var IconButton = function IconButton(_ref) {
  var theme = _ref.theme;
  return {
    MuiIconButton: {
      styleOverrides: {
        root: {
          '&:hover': {
            backgroundColor: theme.palette.grey[5008]
          }
        }
      }
    }
  };
};